import * as z from "zod/v4";

export const getConfiguredServiceCodes = {
  name: "getConfiguredServiceCodes" as const,
  input: z.null(),
  output: z.object({ serviceCodes: z.array(z.string()) }),
};
